<section id="content" *ngIf="data">>
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>View Ticket</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/super/'+AppFrontRoutes.ADMIN_TICKET_LIST">{{lang.supportTicket}}</a>
          </li>
          <li>
            <a>{{lang.viewTicket}}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="page page-full page-chat">

      <!-- row -->
      <div class="tbox tbox-sm">
        <div class="tcol">
            
            <div class="designer_category">
                <div class="ticket_row">
                    <div class="ticket_left">
                        <h2>{{lang.ticketNo}} <span>{{ticket.ticket_no}}</span> </h2>
                        <h3>{{lang.category}}: <strong>{{categories[ticket.category_id].description}}</strong></h3>
                        <h3>{{lang.created}}: {{ticket.created * 1000 | date:'dd-MM-yyyy HH:mm:ss':this.timezone}}</h3>
                    </div>
                    <div class="ticket_right">
                        <button type="button" class="btn btn-success btn-sm br-2" *ngIf="ticket.status == 1">{{lang.open}}</button>
                        <button type="button" class="btn btn-danger btn-sm br-2" *ngIf="ticket.status == 2">{{lang.closed}}</button>
                    </div>
                </div>
                <hr>
                <p [innerHTML]="ticket.content"></p>
            </div>

        
                  <!-- right side body -->
                  <div class="p-15">

                    <!-- chats -->
                    <ul class="chats p-0">


                      
                        <li *ngFor="let conversation of conversations" [ngClass]="{'in' : conversation.user_id == 'ADMIN', 'out' : conversation.user_id != 'ADMIN'}">
                            <div class="media">
                                <div [ngClass]="{'pull-left' : conversation.user_id == 'ADMIN', 'pull-right two' : conversation.user_id != 'ADMIN'}">
                                    <img class="media-object img-circle size-30x30" [src]="userDetails[conversation.user_id].image" alt="">
                                </div>
                                <div class="media-body">
                                    <p class="media-heading"><a href="#" class="name">{{userDetails[conversation.user_id].name}} </a><span class="datetime">at {{conversation.created * 1000 | date:'dd-MM-yyyy HH:mm:ss':this.timezone}}</span></p>
                                    <span class="body" [innerHTML]="conversation.content"></span>
                                </div>
                            </div>
                        </li>
                        <li class="out" *ngIf="ticket.status == 1">
                            <div class="media">
                                <div class="pull-right">
                                    <img class="one media-object img-circle size-30x30" [src]="userDetails[details.user_id].image" alt="">
                                </div>
                                <div class="media-body">
                                    <div>

                                        <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                                            <div *ngFor="let validation of msg">
                                              <div class="error-message"
                                                *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                                                {{validation.message}}
                                              </div>
                                            </div>
                                        </ng-template>

                                        <form [formGroup]="replyForm" class="form-validation" (ngSubmit)="replyFormSubmit()">
                                            <ckeditor
                                            formControlName="content"
                                            [ngClass]="formErrorClass(replyForm.controls.content, replyFormSubmitted)"
                                            ></ckeditor>

                                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                                                [ngTemplateOutletContext]="{msg:replyFormErrorMsg.content, value:replyForm.controls.content, submitted:replyFormSubmitted }">
                                            </ng-template>
                                        
                                            <div class="panel-footer text-left">
                                                <button class="btn btn-greensea btn-ef btn-ef-7 btn-ef-7b b-0 br-2"><i class="fa fa-envelope"></i> {{lang.sendReply}}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <!-- / chats -->

                </div>
                <!-- /right side body -->

                  
                
        </div>
      </div>

    </div>

  </div>
</section>